var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name == 'Home')?_c('div',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.version)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }